export const CONSTANTS = {
  notAuthorized: 141,
  errorToken: 142,
  expiredAccessToken: 143,
  errorValidationRole: 132,
  invalidReportToken: 147,
  reportTokenExpired: 148
}
